import { MacroEventType } from '../deviceProfiles/MacroEvent';

export interface MacroActionReference {
    eventType: MacroEventType;
    key?: string;
    deviceTypeCustomActionId?: string;
}

export interface IncompatibleActionGroup {
    actions: MacroActionReference[];
    reason?: string;
}

export interface RequiredPauseBetweenRule {
    actionA: MacroActionReference;
    actionB: MacroActionReference;
    minimumPauseMilliseconds: number;
    bidirectional: boolean;
}

export interface MacroStepRule {
    eventType: MacroEventType;
    key?: string;
    maximumUsePerMacro?: number;
    deviceTypeCustomActionId?: string;
    maximumHoldTimeMilliseconds?: number;
    disableLatching: boolean;
    holdTimeJitterMinMilliseconds?: number;
    holdTimeJitterMaxMilliseconds?: number;
}

export default interface DeviceTypeThrottleRules {
    disableVoiceInput: boolean;
    disableHotkeyInput: boolean;
    disableCameraInput: boolean;
    disableMultiInputs: boolean;
    maximumCommandsPerSecond?: number;
    maximumCommandsPerMinute?: number;
    maximumMacroLength?: number;
    holdTimeJitterMinMilliseconds?: number;
    holdTimeJitterMaxMilliseconds?: number;
    pauseTimeJitterMinMilliseconds?: number;
    pauseTimeJitterMaxMilliseconds?: number;
    incompatibleActionGroups?: IncompatibleActionGroup[];
    requiredPauseBetweenRules?: RequiredPauseBetweenRule[];
    macroStepRules?: MacroStepRule[];
}

export const getDefaultThrottleRules = (): DeviceTypeThrottleRules => ({
    disableVoiceInput: false,
    disableHotkeyInput: false,
    disableCameraInput: false,
    disableMultiInputs: false,
    maximumCommandsPerSecond: undefined,
    maximumCommandsPerMinute: undefined,
    maximumMacroLength: undefined,
    holdTimeJitterMinMilliseconds: undefined,
    holdTimeJitterMaxMilliseconds: undefined,
    pauseTimeJitterMinMilliseconds: undefined,
    pauseTimeJitterMaxMilliseconds: undefined,
    incompatibleActionGroups: undefined,
    requiredPauseBetweenRules: undefined,
    macroStepRules: undefined,
});
